export { default } from "./Setting.vue";
